/**
 * Partes del módulo F-22 Régimen 14 D N°8 (Pro Pyme Transparente) comunes a todos los
 * años con los mismos recuadros 22 y 23 (AT 2025 y AT 2026). Cada año las re-exporta
 * desde su <año>/14d8/index.js junto con su persistencia y sus dataLoaders.
 */
import sociosDividendosService from '../../../../services/sociosDividendosService';
import declaracionesJuradasService from '../../../../services/declaracionesJuradasService';

export { recalculate } from './formulas';
export { default as AntecedentesSection } from './sections/AntecedentesSection';
export { default as R22Section } from './sections/R22Section';
export { default as R23Section } from './sections/R23Section';
export { default as PropietariosSection } from './sections/PropietariosSection';
export { default as LiquidacionSection } from './sections/LiquidacionSection';

/**
 * Data loaders que usa todo año: la DJ 1947 guardada del mismo año (base imponible y
 * reparto) y los socios. Cada entrada: key (id), loader (fetch), apply (inyecta datos).
 * @param {number} anioTributario
 */
export const loadersComunes = (anioTributario) => [
  {
    key: 'dj1947',
    loader: (idCompany, token) => declaracionesJuradasService.getDJ1947DelAnio(idCompany, anioTributario, token),
    apply: (formData, dj) => {
      if (!dj?.base) return formData;
      return {
        ...formData,
        dj1947: { id_declaracion: dj.declaracion.id, base: dj.base, propietarios: dj.propietarios, reparto: dj.reparto },
      };
    },
  },
  {
    key: 'socios',
    loader: (idCompany, token) => sociosDividendosService.getSocios(idCompany, token),
    apply: (formData, sociosApi) => {
      if (!sociosApi || sociosApi.length === 0) return formData;
      const socios = sociosApi.map((s) => ({
        nombre: s.nombre || '',
        rut: s.rut || '',
        participacion: parseFloat(s.porcentaje_participacion) || 0,
        capitalHistorico: parseInt(s.monto_clp_aportado) || 0,
      }));
      return { ...formData, antecedentes: { ...formData.antecedentes, socios } };
    },
  },
];

/**
 * Avisos de la página del certificado de renta pagada. En 14 D N°8 el certificado no
 * genera asientos (la empresa no paga primera categoría y sus PPM van a los
 * propietarios): si aun así trae un total a pagar, se avisa para registrarlo a mano.
 * @param {Object} pagado - Fila del certificado (cod_XXXX)
 * @returns {string[]}
 */
export const avisosCertificado = (pagado) => {
  const totalAPagar = Number(pagado?.cod_91) || 0;
  if (totalAPagar <= 0) return [];
  return [
    `El certificado trae un total a pagar de $${totalAPagar.toLocaleString('es-CL')} (código 91). En el régimen 14 D N°8 TAXI no contabiliza el certificado: registra ese pago con un asiento manual.`,
  ];
};

// `editable: true` marca las secciones que se muestran ANTES de calcular; el resto se
// muestra en RentaSavedView con los datos ya guardados
export const SECTIONS = [
  { id: 'antecedentes', label: 'Antecedentes', component: 'AntecedentesSection', editable: true },
  { id: 'liquidacion', label: 'Impuesto a Pagar', component: 'LiquidacionSection' },
  { id: 'r22', label: 'R22', component: 'R22Section' },
  { id: 'r23', label: 'R23', component: 'R23Section' },
  { id: 'propietarios', label: 'Propietarios', component: 'PropietariosSection' },
];
